import Cookies from 'universal-cookie';

const cookies = new Cookies();

export const prepareHeaders = (headers, {getState}) => {
  const discordUserInfo = getState().user?.discordUserInfo;
  headers.set('token', discordUserInfo.token);
  return headers;
};
